const {
  REACT_APP_USER_FILES_S3_BUCKET,
  REACT_APP_USER_FILES_S3_BUCKET_REGION,
  REACT_APP_S3_BUCKET,
  REACT_APP_S3_DIR,
  REACT_APP_S3_REGION,
  REACT_APP_S3_ACCESS_KEY,
  REACT_APP_S3_SECRET_ACCESS_KEY,
  REACT_APP_S3_URL,
  REACT_APP_API_URL,
  REACT_APP_PROJECT_REGION,
  REACT_APP_COGNITO_IDENTITY_POOL_ID,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_CLIENT_ID,
  REACT_APP_CACHE_CONTROL_MAX_AGE,
  REACT_APP_CLOUDFRONT_DISTRIBUTION_ID,
  REACT_APP_S3_BUCKET_URL,
} = process.env;

const S3_CONFIG = {
  bucketName: REACT_APP_S3_BUCKET,
  dirName: REACT_APP_S3_DIR,
  region: REACT_APP_S3_REGION,
  accessKeyId: REACT_APP_S3_ACCESS_KEY,
  secretAccessKey: REACT_APP_S3_SECRET_ACCESS_KEY,
  s3Url: REACT_APP_S3_URL,
};

const API_URL = REACT_APP_API_URL;

const AMPLIFY_CONFIG = {
  aws_project_region: REACT_APP_PROJECT_REGION,
  aws_cognito_identity_pool_id: REACT_APP_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: REACT_APP_COGNITO_REGION,
  aws_user_pools_id: REACT_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: REACT_APP_COGNITO_CLIENT_ID,
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: REACT_APP_USER_FILES_S3_BUCKET,
  aws_user_files_s3_bucket_region: REACT_APP_USER_FILES_S3_BUCKET_REGION,
};

const DEPLOY_CONFIG = {
  CACHE_CONTROL_MAX_AGE: REACT_APP_CACHE_CONTROL_MAX_AGE,
  CLOUDFRONT_DISTRIBUTION_ID: REACT_APP_CLOUDFRONT_DISTRIBUTION_ID,
  S3_BUCKET_URL: REACT_APP_S3_BUCKET_URL,
};

module.exports = {
  S3_CONFIG,
  API_URL,
  AMPLIFY_CONFIG,
  DEPLOY_CONFIG,
};
